import { GridLogicOperator } from '@mui/x-data-grid-premium';
import { IGridFilterModel, IGridSortModel } from 'src/components';
import {
  CustomFieldPredicate,
  CustomGroupPredicate,
  CustomSort
} from 'src/models/api.request';
import moment, { unitOfTime } from 'moment';
import printService from 'src/services/Printer/print.service';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import store from 'src/store';
import CryptoJS from 'crypto-js/crypto-js'

export class helper {
  static convertApiFilters = <T>(
    filterModel: IGridFilterModel
  ): CustomGroupPredicate<T> => {
    var result: CustomGroupPredicate<T> = {
      groupOperator: 'and',
      predicates: []
    };
    if (filterModel) {
      result = {
        groupOperator:
          filterModel.logicOperator == GridLogicOperator.Or ? 'or' : 'and'
      };
      var predicates: Array<CustomFieldPredicate<T>> = [];
      for (var i in filterModel.items) {
        var item = filterModel.items[i];
        var filter: CustomFieldPredicate<T> = {
          fieldName: item.field as any,
          value1: item.value,
          operator: '='
        };

        switch (item.operator) {
          case '!=':
          case 'isNotEmpty':
          case 'not':
            filter.operator = '=';
            filter.not = true;
            break;
          case '<':
          case 'before':
            filter.operator = '<';
            break;
          case '<=':
          case 'onOrBefore':
            filter.operator = '<=';
            break;
          case '=':
          case 'equals':
          case 'is':
          case 'isEmpty':
            filter.operator = '=';
            break;
          case '>':
          case 'after':
            filter.operator = '>';
            break;
          case '>=':
          case 'onOrAfter':
            filter.operator = '>=';
            break;
          case 'contains':
            filter.operator = 'like';
            break;
          case 'endsWith':
            filter.operator = 'endsWith';
            break;
          case 'startsWith':
            filter.operator = 'startsWith';
            break;
          case 'isAnyOf':
            filter.operator = 'in';
            if (!filter.value1 || filter.value1?.length == 0) continue;
            break;
          case 'between':
            if (!filter.value1 || filter.value1?.length == 0) continue;
            for (let i = 0; i < filter.value1.length; i++) {
              if (i === 0) filter.value1 = filter.value1[i];
              else filter.value2 = filter.value1[i];
            }

            filter.operator = 'between';
            break;
        }
        if (filter.fieldName.indexOf('Bool') > -1) {
          if (!filter.value1) continue;
          filter.fieldName = filter.fieldName.replace('Bool', '') as any;
          filter.value1 = filter.value1 == 'true' ? 'E' : 'H';
        }
        predicates.push(filter);
      }
      result.predicates = predicates;
    }
    return result;
  };
  static convertApiSorts = <T>(
    sortModel: IGridSortModel,
    defaultSort?: CustomSort<T>
  ): Array<CustomSort<T>> => {
    var sorts: Array<CustomSort<T>> = [];
    if (sortModel?.length > 0) {
      sorts = sortModel.map((m) => {
        return {
          fieldName: m.field as any,
          ascending: m.sort === 'desc' ? false : true
        };
      });
    } else if (defaultSort) {
      sorts.push(defaultSort);
    }
    return sorts;
  };
  static startDate = () => {
    return moment().startOf("day").format('yyyy-MM-DDTHH:mm');
  };
  static endDate = () => {
    return moment().endOf("day").format('yyyy-MM-DDTHH:mm');
  };
  static startWeeklyDate = () => {
    return moment().startOf("isoWeek").format('yyyy-MM-DDTHH:mm');
  };
  static endWeeklyDate = () => {
    return moment().endOf("isoWeek").format('yyyy-MM-DDTHH:mm');
  };

  static startWeeklyDateWithValue = (datevalue: any) => {
    return moment(datevalue).startOf("isoWeek").format('yyyy-MM-DDTHH:mm');
  };
  static endWeeklyDateVithValue = (datevalue: any) => {
    return moment(datevalue).endOf("isoWeek").format('yyyy-MM-DDTHH:mm');
  };

  static startMonthlyDate = () => {
    return moment().startOf("months").format('yyyy-MM-DDTHH:mm');
  };
  static endMonthlyDate = () => {
    return moment().endOf("months").format('yyyy-MM-DDTHH:mm');
  };
  static startYearDate = () => {
    return moment().startOf('year').format('yyyy-MM-DDTHH:mm');
  };
  static endYearDate = () => {
    return moment().endOf('year').format('yyyy-MM-DDTHH:mm');
  };
  static datetimeNow = () => {
    return moment().format('yyyy-MM-DDTHH:mm:ss');
  };
  static datetimeToday = () => {
    return moment().format('yyyy-MM-DD');
  };
  static datetimeTodayAddDay = (day: number) => {
    return moment().add(day, 'day').format('yyyy-MM-DDT00:00');
  };
  static datetimeNowAddDay = (day: number) => {
    return moment().add(day, 'day').format('yyyy-MM-DDTHH:mm');
  };
  static dateValueFormat = (datevalue: any) => {
    return moment(datevalue).format('yyyy-MM-DD');
  };
  static dateValueFormat2 = (datevalue: any) => {
    return moment(datevalue).format('DD.MM.yyyy');
  };
  static dateValueFormat3 = (datevalue: any) => {
    return moment(datevalue).format('DD.MM.yyyy HH:mm');
  };
  static dateTimeValueFormat = (dateTime: any) => {
    return moment(dateTime).format('yyyy-MM-DDTHH:mm');
  };
  static timeValueFormat = (datevalue: any) => {
    return moment(datevalue).format('HH:mm');
  };
  static jsonToDateTime = (jsonDate: string) => {
    return moment(jsonDate)
  };
  static formatToDateTime = (date: string, format: string) => {
    return moment(date, format)
  };
  static dateIncOrDec = (options: number, dateValue: any, mount: number) => {
    // options : 1(Artırma), 2 (Azaltma) -  mount : Artış veya azalış miktarı
    var date = new Date(dateValue);
    if (options == 1) {
      date.setDate(date.getDate() + mount);
    } else if (options == 2) {
      date.setDate(date.getDate() - mount);
    } else {
      return;
    }
    return this.dateValueFormat(date);
  };
  static yearIncOrDec = (options: number, dateValue: any, mount: number) => {
    // options : 1(Artırma), 2 (Azaltma) -  mount : Artış veya azalış miktarı
    var date = new Date(dateValue);
    if (options == 1) {
      date.setFullYear(date.getFullYear() + mount);
    } else if (options == 2) {
      date.setFullYear(date.getFullYear() - mount);
    } else {
      return;
    }
    return this.dateValueFormat(date);
  };
  static weekStartDate = (dateValue: any) => {
    var date = new Date(dateValue);
    var day = date.getDay() - 1;
    return this.dateIncOrDec(2, dateValue, day);
  };

  static getTimeToNumber = (dateValue: any) => {
    var date = new Date(dateValue);
    var res = date.getTime();
    return res;
  };

  static UpperCaseAsc = (str: any): string => {
    if (!str) return str;
    var resStr = '';
    for (var i = 0; i < str.length; i++) {
      switch (str[i]) {
        case 'i':
        case 'İ':
          resStr += 'I';
          break;
        case 'ü':
        case 'Ü':
          resStr += 'U';
          break;
        case 'ö':
        case 'Ö':
          resStr += 'O';
          break;
        case 'ş':
        case 'Ş':
          resStr += 'S';
          break;
        case 'ğ':
        case 'Ğ':
          resStr += 'G';
          break;
        case 'ç':
        case 'Ç':
          resStr += 'C';
          break;
        default:
          resStr += str[i]?.toString()?.toUpperCase();
          break;
      }
    }
    return resStr;
  };
  static jsonToShortDateString = (jsonDate: any): string => {
    if (!jsonDate) return '';
    return moment(jsonDate).format('DD.MM.yyyy');
  };
  static jsonToLongDateString = (jsonDate: any): string => {
    if (!jsonDate) return '';
    return moment(jsonDate).format('DD.MM.yyyy HH:mm:ss');
  };
  static jsonToLongTimeString = (jsonDate: any): string => {
    if (!jsonDate) return '';
    return moment(jsonDate).format('HH:mm:ss');
  };
  static jsonToTimeString = (jsonDate: any): string => {
    if (!jsonDate) return '';
    return moment(jsonDate).format('HH:mm');
  };
  static datetimeAddDay = (date: Date | string, day: number) => {
    return moment(date).add(day, 'day').format('yyyy-MM-DD');
  };
  static getLocaleFromLang = (lang: string): string => {
    switch (lang) {
      case 'US':
        return 'en-US';
      case 'RU':
        return 'ru-RU';
      case 'FR':
        return 'fr-FR';
      case 'AZ':
        return 'az-AZ';
      case 'UZ':
        return 'uz-UZ';
      default:
        return 'tr-TR';
    }
  };
  static getCurrencyFormat = (val: number, digit: number = 2): string => {
    if (isNaN(val))
      return "";

    let lang = localStorage.getItem('lang') ?? 'TR';
    let cur = 'TRY';
    if (lang === 'AZ') {
      lang = 'az-AZ';
      cur = 'AZN';
    }
    else if (lang === 'TR' || lang == null) {
      lang = 'tr-TR';
      cur = 'TRY';
    }
    else if (lang === 'US') {
      lang = 'en-US';
      cur = 'USD';
    }
    else if (lang === 'RU') {
      lang = 'ru-RU';
      cur = 'RUB';
    }
    else if (lang === 'FR') {
      lang = 'fr-FR';
      cur = 'EUR';
    }
    else if (lang === 'UZ') {
      lang = 'uz-UZ';
      cur = 'UZS';
    }
    const currencyFormatter = new Intl.NumberFormat(lang, {
      style: 'currency',
      currency: cur,
      minimumFractionDigits: digit
    });

    return currencyFormatter.format(val);
  };
  static getNumberFormat = (val: number, digit: number = 2): string => {
    if (isNaN(val))
      return "";
    let lang = localStorage.getItem('lang') ?? 'TR';
    let cur = 'TRY';
    if (lang === 'AZ') {
      lang = 'az-AZ';
      cur = 'AZN';
    }
    else if (lang === 'TR' || lang == null) {
      lang = 'tr-TR';
      cur = 'TRY';
    }
    else if (lang === 'US') {
      lang = 'en-US';
      cur = 'USD';
    }
    else if (lang === 'RU') {
      lang = 'ru-RU';
      cur = 'RUB';
    }
    else if (lang === 'FR') {
      lang = 'fr-FR';
      cur = 'EUR';
    }
    else if (lang === 'UZ') {
      lang = 'uz-UZ';
      cur = 'UZS';
    }
    const numberFormatter = new Intl.NumberFormat(lang, {
      style: 'decimal',
      currency: cur,
      minimumFractionDigits: digit
    });

    return numberFormatter.format(val)
  };

  static setBarcodePrintTolocaLStorage = () => {
    printService.pcinfo().then((res) => {
      localStorage.setItem(
        'barcodePrinter',
        res.data['defaultPrinter'].toString()
      );
    }).catch(() => { })
  };
  static setLaserPrintTolocaLStorage = () => {
    printService.pcinfo().then((res) => {
      localStorage.setItem(
        'laserPrinter',
        res.data['defaultPrinter'].toString()
      );
    }).catch(() => { })
  };
  static objectToNumber = (val: any): number => {
    if (val == null || val == '' || val == 'undefined') return null;
    return Number(val);
  };

  static isValidDate = (val: any, nullable: boolean): boolean => {
    if (val == '' && nullable) return true;
    if (val == null && nullable) return true;
    return moment(val).isValid();
  };
  static isNumber = (val: string): boolean => {
    if (val == null || val == '') return false;
    val = val.trim();
    let nBoy = val.length;
    if (nBoy == 0) return false;
    for (let i = 0; i < val.length; i++) {
      let cKarakter = val[i];
      if (!(cKarakter >= '0' && cKarakter <= '9')) return false;
    }
    return true;
  };

  static objectToString = (val: any): string => {
    if (!val)
      return "";
    return val?.toString();
  };

  static upperCase = (val: string): string => {
    let res = "";
    if (!val)
      return res;
    for (let i = 0; i < val.length; i++) {
      switch (val[i]) {
        case "ı":
          res += "I";
          break;
        case "i":
          res += "İ";
          break;
        case "ç":
          res += "Ç";
          break;
        case "ü":
          res += "Ü";
          break;
        case "ğ":
          res += "Ğ";
          break;
        case "ş":
          res += "Ş";
          break;
        case "ö":
          res += "Ö";
          break;
        default:
          res += val[i].toUpperCase();
          break;
      }
    }
    return res;
  }
  static changeArray = <T>(arr: Array<T>, item: T, key: keyof T & string): Array<any> => {
    if (!arr)
      return [];
    if (arr.length === 0)
      return [];

    let find = false;
    let res = arr.map(m => {
      if (m[key] === item[key]) {
        find = true;
        return item;
      }
      else {
        return m;
      }
    })
    if (!find)
      res.unshift(item);
    return res;
  }
  static binlik = (n) => {
    return n.toFixed(2).replace('.', ',').replace(/\d{3}(?=(\d{3})*,)/g, function (s) {
      return '.' + s
    })
  }
  /**
   * Sayıyı formatlar
   * @param num Formatlanacak sayı
   * @param digits Virgülden sonraki basamak sayısı
   * @returns string
  */
  static formatNumber(num: number, digits: number): any {
    if (num === undefined) {
      return 0;
    }
    if (isNaN(num)) {
      return "";
    }
    return num.toFixed(digits).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }
  static camelCase = (value: string, separator: string = " "): string => {
    if (!value)
      return value;
    var newNameArr = value.split(separator);
    const newArr = newNameArr.map((m, i) => {
      let newM = "";
      m = helper.UpperCaseAsc(m)
      for (var c = 0; c < m.length; c++) {
        if (i === 0)
          newM += m[c].toLowerCase()
        else if (c === 0)
          newM += m[c].toUpperCase()
        else newM += m[c].toLowerCase()
      }
      return newM;
    });
    return newArr.join("");
  }
  static blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onerror = (e) => reject(fileReader.error);
      fileReader.onloadend = (e) => {
        const dataUrl = fileReader.result as string;
        // remove "data:mime/type;base64," prefix from data url
        const base64 = dataUrl.substring(dataUrl.indexOf(',') + 1);
        resolve(base64);
      };
      fileReader.readAsDataURL(blob);
    });
  }
  static resimMi = (type: string): boolean => {
    if (!type)
      return false;
    const file = [
      "apng",
      "avif",
      "gif",
      "jpg",
      "jpeg",
      "jfif",
      "pjpeg",
      "pjp",
      "png",
      "svg",
      "webp",
    ]
    return file.filter(f => f === type.replace(".", "").trim())?.length > 0
  }
  static dateTimeDiffs = (sonTarih: string, ilkTarih: string,
    unitOfTime: unitOfTime.Diff, precise?: boolean): number => {
    var a = moment(sonTarih);
    var b = moment(ilkTarih);
    return a.diff(b, unitOfTime, precise)
  };
  static datetimeToyear = () => {
    return moment().format('yyyy');
  };
  static getParameterName = (pkParameter: number, parametreGrupEnum: ParametreGrupEnum | number) => {
    const parameterCache = store.getState().parameters.data;
    return parameterCache.find(
      (f) => f.key === pkParameter && f.grupId === parametreGrupEnum
    )?.value;
  }

  private static _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  static base64Encode = (input) => {
    if (!input)
      return "";
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = this.utf8_encode(input);

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }
    return output;
  }

  static base64Decode = (input) => {
    if (!input)
      return "";
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\\+\\/\\=]/g, "");

    while (i < input.length) {

      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = this.utf8_decode(output);

    return output;
  }
  private static utf8_encode = (string) => {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      }
      else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      }
      else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }

  // private method for UTF-8 decoding
  private static utf8_decode = (utftext) => {
    var string = "";
    var i = 0;
    var c = 0;
    var c2 = 0;
    var c3 = 0;

    while (i < utftext.length) {

      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      }
      else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      }
      else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }
    }
    return string;
  }
  static fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString().substr(reader.result.toString().indexOf(',') + 1));
      reader.onerror = error => reject(error);
    });
  }
  static padLeadingZeros = (num, size) => {
    var s = num + '';
    while (s.length < size) s = '0' + s;
    return s;
  };

  static encryptBF = (val: string): string => {
    var key = CryptoJS.enc.Utf8.parse("8080808080808080")
    var iv = CryptoJS.enc.Utf8.parse("8080808080808080")
    return CryptoJS.AES.encrypt(val, key,
      {
        // keysize: 256,
        iv: iv,
        // mode: CryptoJS.mode.CBC,
        // padding: CryptoJS.pad.Pkcs7
      }
    ).toString()
  }

  static decryptBF = (val: any): string => {
    const encryptedData = CryptoJS.enc.Base64.parse(val);
    var key = CryptoJS.enc.Utf8.parse("8080808080808080")
    var iv = CryptoJS.enc.Utf8.parse("8080808080808080")
    var decrypt = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData }, key,
      { iv: iv });

    return decrypt.toString(CryptoJS.enc.Utf8)
  }

  static getUniqueItemsByProperty = <T>(arr: Array<T>, key: keyof T): Array<T> => {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }
  static getUniqueItemsByProperties = <T>(arr: Array<T>, keys: Array<keyof T>): Array<T> => {
    return [...new Map(arr.map(item => [keys.map(key => item[key]).join('|'), item])).values()]
  }

  static stringIsNullOrEmpty = (value: string): boolean => {
    return !value || String(value).trim() === '';
  };

  static numberIsNullOrZero = (value: number): boolean => {
    return !value || value <= 0;
  };

  static beforeDays = (date: Date, gun: number): Date => {
    const yeniTarih = new Date(date);
    yeniTarih.setDate(yeniTarih.getDate() - gun);
    return yeniTarih;
  };

  static kisaMetin = (metin: string = '', maxUzunluk: number = metin?.length) => metin?.length > maxUzunluk ? `${metin?.slice(0, maxUzunluk)}...` : metin;


  static currentTime = () => {
    return moment().format("HH:mm")
  };
  static nvl = <T>(value: T | null | undefined, defaultValue: T): T => {
    return value ?? defaultValue;
  };

  static base64toString = (base64, type = 'application/octet-stream') => fetch(`data:${type};base64,${base64}`).then(res => res.text());

  static getQueryParams = (val: string, params: string): string => {
    // var params = window.location.search.substring(1);
    var vars = params.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == val) {
        return pair[1];
      }
    }
    return ("");
  }
}
